  (() => {
    const count = document.querySelector('#zp-footer [data-zp-tree-count]');
    if (!count) return;
    const today = new Date();
    const currentDay = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    const startDay = Date.UTC(2026, 2, 17);
    count.textContent = 35 + Math.floor((currentDay - startDay) / 604800000);
  })();
